import { shallowEqual } from 'react-redux';

import { Button, ButtonGroup, Card, Icon } from '@zillow/constellation-10';
import { IconHandshakeFilled } from '@zillow/constellation-icons';

import { useSelector } from '../../../../selectors/useSelector';

import ManageTenantsCSEvents from '../../../../model/ClickstreamEvent/ManageTenantsCSEvents';

import EmptyState from '../../../EmptyState';

type Props = {
  title: string;
  description: string;
  primaryCtaText: string;
  primaryCtaUrl: string;
  secondaryCtaText?: string;
  secondaryCtaUrl?: string;
};

const EmptyLeasesCard = ({
  title,
  description,
  primaryCtaText,
  primaryCtaUrl,
  secondaryCtaText = '',
  secondaryCtaUrl = '',
}: Props) => {
  const { user } = useSelector((state) => {
    return {
      user: state.user,
    };
  }, shallowEqual);

  const hasSecondaryCTA = !!(secondaryCtaText && secondaryCtaUrl);

  const handleEmptyLeasesCardPrimaryCTAClick = () => {
    ManageTenantsCSEvents.GetStarted({ user });
  };

  return (
    <Card
      data-testid="EmptyLeasesCard"
      tone="neutral"
      elevated={false}
      css={{ paddingInline: 'looser', paddingBlock: 'loosest' }}
    >
      <EmptyState
        icon={<Icon size="md" css={{ color: 'icon.subtle' }} render={<IconHandshakeFilled />} />}
        heading={title}
        headingLevel={4}
        body={description}
        align="left"
        useCard={false}
        actions={
          <ButtonGroup
            aria-label="lease actions"
            orientation="horizontal"
            css={{
              flexDirection: { base: 'column', md: 'row' },
              alignItems: { base: 'stretch', md: 'start' },
            }}
          >
            <Button
              asChild
              tone="brand"
              emphasis="filled"
              onClick={handleEmptyLeasesCardPrimaryCTAClick}
              data-eventid={ManageTenantsCSEvents.GetStarted.data_event_id}
            >
              <a href={primaryCtaUrl}>{primaryCtaText}</a>
            </Button>
            {hasSecondaryCTA && (
              <Button asChild tone="brand" emphasis="outlined" data-testid="EmptyLeasesCard-DefaultButton">
                <a href={secondaryCtaUrl}>{secondaryCtaText}</a>
              </Button>
            )}
          </ButtonGroup>
        }
      />
    </Card>
  );
};

export default EmptyLeasesCard;
